import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { TotalSalaryChartData } from "models/propTypes/additionalChartData";
//#endregion
//#region components
import { ChartToggle, ViewPanel } from "components/common";
import TotalSalaryAdditionalChartData from "../_partials/totalSalaryAdditionalChartData";
import TotalSalaryChart from "./totalSalaryChart";
import { useReportWidgetAdditionalData } from "./useReportWidgetAdditionalData";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const TotalSalaryChartWrapper: React.FC = () => {
  const { additionalData: chartData, onChartSuccessHandler } = useReportWidgetAdditionalData<TotalSalaryChartData>();

  return (
    <ViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.TotalSalaryChartTitle)}
      appearance="sm"
      gridSize="md"
      isCanvasContent
      topRightContent={<ChartToggle />}
      additionalContent={
        chartData ? (
          <TotalSalaryAdditionalChartData
            currentPeriod={{ start: chartData?.currentPeriodStart, end: chartData?.currentPeriodEnd }}
            currentPeriodAmount={chartData?.totalForCurrentPeriod}
            previousPeriod={{ start: chartData?.previousPeriodStart, end: chartData?.previousPeriodEnd }}
            previousPeriodAmount={chartData?.totalForPreviousPeriod}
            currentPeriodDeviationPercentage={chartData?.percentageChangeForCurrentPeriod}
            previousPeriodDeviationPercentage={chartData?.percentageChangeForPreviousPeriod}
          />
        ) : undefined
      }
    >
      <TotalSalaryChart onChartSuccessHandler={onChartSuccessHandler} />
    </ViewPanel>
  );
};

export default TotalSalaryChartWrapper;
